module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/new/assessment_achievements/6_4f478c7d34ce68c0119837464bc1fb8a.png";